import { resolveLink as o, resolveImage as c, resolveTheme as a, resolveIcon as i } from "../../../helpers/index.js";
const l = (s) => {
  const r = [];
  return s.areas?.forEach((p) => {
    p?.items.forEach((e) => {
      const n = {
        header: e.content.properties?.header,
        subject: e.content.properties?.subject,
        text: e.content.properties?.text,
        cta: e.content.properties?.link && o(e.content.properties?.link?.[0])
      };
      switch (e.content.contentType) {
        case "shared_contactBox":
          r.push({
            ...n,
            contactList: e.content.properties?.contactList?.items.map(
              (t) => ({
                icon: i(t.content.properties?.ikon),
                text: t.content.properties?.content,
                link: t.content.properties?.link && o(t.content.properties?.link?.[0])
              })
            ),
            variant: "contact"
          });
          break;
        case "shared_freestyleBox":
          r.push({
            ...n,
            image: e.content.properties?.image?.[0] && c(e.content.properties?.image),
            variant: e.content.properties?.variant?.toLowerCase(),
            theme: a(e.content.properties?.theme)
          });
          break;
      }
    });
  }), {
    header: "",
    items: r
  };
};
export {
  l as cardsDeliveryApiParser
};
